const defaultVisibility = () => ({
  showProcedureTab: false,
  showAssessmentTab: false,
  showQuizFinal: false,
  showAssessmentScheduledModal: false,
  showInfoStepAlert: false,
  tabIndex: 0,
});

const finalAssessmentScheduled = {
  showProcedureTab: false,
  showAssessmentTab: true,
  showQuizFinal: false,
  showAssessmentScheduledModal: true,
  showInfoStepAlert: false,
  tabIndex: 1,
};

const quizSatisfactionAnswered = {
  showProcedureTab: false,
  showAssessmentTab: true,
  showQuizFinal: false,
  showAssessmentScheduledModal: false,
  showInfoStepAlert: false,
  tabIndex: 4,
};

const finishedFlow = {
  showProcedureTab: false,
  showAssessmentTab: false,
  showQuizFinal: false,
  showAssessmentScheduledModal: false,
  showInfoStepAlert: true,
  tabIndex: 1,
};

const scheduledAssessment = () => finalAssessmentScheduled;

const satisfactionAnswered = () => quizSatisfactionAnswered;

const finished = () => finishedFlow;

const getAssessmentMade = ({ scheduleEvents, numberEvents }) => {
  const attended = scheduleEvents.filter(
    (e) => e.type === "PROCEDURE" && e.attended === true
  ).length;

  const showFinal = numberEvents !== null && attended === numberEvents;

  return {
    showProcedureTab: true,
    showAssessmentTab: false,
    showQuizFinal: showFinal,
    showAssessmentScheduledModal: false,
    showInfoStepAlert: false,
    tabIndex: 3,
  };
};

const redFlagQuizAnswered = () => ({
  showProcedureTab: false,
  showAssessmentTab: true,
  showQuizFinal: false,
  showAssessmentScheduledModal: false,
  showInfoStepAlert: false,
  showDefineSessionsOriginModal: false,
  tabIndex: 4,
});

const noRedFlagQuizAnswered = ({
  scheduleEvents,
  numberEvents,
  eventsDefinedBy,
}) => {
  const hasAttendedTestProcedure = scheduleEvents.some(
    (e) => e.type === "TEST_PROCEDURE" && e.attended === true
  );
  const showDefineSessionsOriginModal =
    numberEvents == null && eventsDefinedBy == null;
  const patientKnows = numberEvents !== null && eventsDefinedBy === "PATIENT";
  const waitingForDoctor =
    numberEvents === null && eventsDefinedBy === "DOCTOR";

  if (showDefineSessionsOriginModal) {
    return {
      showProcedureTab: false,
      showAssessmentTab: false,
      showQuizFinal: false,
      showAssessmentScheduledModal: false,
      showInfoStepAlert: false,
      showDefineSessionsOriginModal: true,
      tabIndex: 1,
    };
  }

  if (patientKnows) {
    return {
      showProcedureTab: true,
      showAssessmentTab: false,
      showQuizFinal: false,
      showAssessmentScheduledModal: false,
      showInfoStepAlert: true,
      tabIndex: 3,
    };
  }

  if (waitingForDoctor) {
    return {
      showProcedureTab: !hasAttendedTestProcedure,
      showAssessmentTab: hasAttendedTestProcedure,
      showQuizFinal: false,
      showAssessmentScheduledModal: false,
      showInfoStepAlert: true,
      tabIndex: hasAttendedTestProcedure ? 4 : 3,
    };
  }

  return defaultVisibility();
};

const quizAnswered = () => ({
  showProcedureTab: false,
  showAssessmentTab: true,
  showQuizFinal: false,
  showAssessmentScheduledModal: false,
  showInfoStepAlert: true,
  showDefineSessionsOriginModal: false,
  tabIndex: 1,
});

export const rulesForTPatientSurgery = {
  HYPERBARIC_FLOW_NOX: {
    "NO RED FLAG": {
      QUIZ_ANSWERED: noRedFlagQuizAnswered,
      ASSESSMENT_NO_SHOW: noRedFlagQuizAnswered,
      SCHEDULED_ASSESSMENT: scheduledAssessment,
      ASSESSMENT_MADE: getAssessmentMade,
      QUIZ_SATISFACTION_ANSWERED: satisfactionAnswered,
      SCHEDULED_ASSESSMENT_FINAL: scheduledAssessment,
      FINISHED: finished,
    },
    "RED FLAG": {
      QUIZ_ANSWERED: redFlagQuizAnswered,
      ASSESSMENT_NO_SHOW: redFlagQuizAnswered,
      SCHEDULED_ASSESSMENT: scheduledAssessment,
      ASSESSMENT_MADE: getAssessmentMade,
      QUIZ_SATISFACTION_ANSWERED: satisfactionAnswered,
      SCHEDULED_ASSESSMENT_FINAL: scheduledAssessment,
      FINISHED: finished,
    },
  },
  CORE_NOX: {
    "FAST TRACK": {
      QUIZ_ANSWERED: redFlagQuizAnswered,
      SCHEDULED_ASSESSMENT: scheduledAssessment,
      ASSESSMENT_NO_SHOW: redFlagQuizAnswered,
      ASSESSMENT_MADE_RESCHEDULE: redFlagQuizAnswered,
      RESCHEDULED_ASSESSMENT: scheduledAssessment,
      ASSESSMENT_MADE: getAssessmentMade,
      QUIZ_SATISFACTION_ANSWERED: finished,
      FINISHED: finished,
    },
    "SLOW TRACK": {
      QUIZ_ANSWERED: redFlagQuizAnswered,
      SCHEDULED_ASSESSMENT: scheduledAssessment,
      ASSESSMENT_NO_SHOW: redFlagQuizAnswered,
      ASSESSMENT_MADE_RESCHEDULE: redFlagQuizAnswered,
      RESCHEDULED_ASSESSMENT: scheduledAssessment,
      ASSESSMENT_MADE: getAssessmentMade,
      QUIZ_SATISFACTION_ANSWERED: finished,
      FINISHED: finished,
    },
  },
  CORE_SOGAMOSO: {
    "FAST TRACK": {
      QUIZ_ANSWERED: quizAnswered,
      SCHEDULED_ASSESSMENT: scheduledAssessment,
      ASSESSMENT_NO_SHOW: redFlagQuizAnswered,
      ASSESSMENT_MADE_RESCHEDULE: redFlagQuizAnswered,
      RESCHEDULED_ASSESSMENT: scheduledAssessment,
      ASSESSMENT_MADE: getAssessmentMade,
      QUIZ_SATISFACTION_ANSWERED: finished,
      FINISHED: finished,
    },
    "SLOW TRACK": {
      QUIZ_ANSWERED: quizAnswered,
      SCHEDULED_ASSESSMENT: scheduledAssessment,
      ASSESSMENT_NO_SHOW: redFlagQuizAnswered,
      ASSESSMENT_MADE_RESCHEDULE: redFlagQuizAnswered,
      RESCHEDULED_ASSESSMENT: scheduledAssessment,
      ASSESSMENT_MADE: getAssessmentMade,
      QUIZ_SATISFACTION_ANSWERED: finished,
      FINISHED: finished,
    },
  },

  // Ejemplo de reglas específicas para SOGAMOSO
  // HYPERBARIC_FLOW_SOGAMOSO: {
  //   "NO RED FLAG": {
  //     QUIZ_ANSWERED: () => ({
  //       showProcedureTab: true,
  //       showAssessmentTab: false,
  //       showQuizFinal: false,
  //       showAssessmentScheduledModal: false,
  //       showInfoStepAlert: true,
  //       tabIndex: 3,
  //     }),
  //     // ... otras reglas específicas para SOGAMOSO
  //   },
  // },
};
